import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Background = styled.div``;

export const Player = styled.video`
    width: 90%;
    margin: 0 5%;

    @media (min-width: ${breakpoints.lg}px) {
        width: 100%;
        margin: 0;
    }
`;
